/* valuation-panel.js — panel wyceny: otwarty na desktopie, zwijany poniżej 1024.
   Treść formularza jest w HTML; ten skrypt tylko ustawia stan <details>.
   Bez JS panel jest zwinięty z widocznym nagłówkiem-przyciskiem — w pełni
   używalny na każdej szerokości. */
(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');
  const initialize = () => {
    document.querySelectorAll('.valuation-panel__details').forEach(panel => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      // Wynik wysyłki (sukces / błąd) zawsze widoczny — także na telefonie.
      const maWynik = !!panel.querySelector('[data-quotation-result]');
      const sync = () => { panel.open = desktop.matches || maWynik; };
      sync();
      desktop.addEventListener('change', sync);
      // Na desktopie summary jest nagłówkiem, nie przełącznikiem: klawiatura
      // (Enter/Spacja) nie może zwinąć panelu obok banera.
      panel.addEventListener('toggle', () => { if (desktop.matches && !panel.open) panel.open = true; });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
